

  <!-- Header -->
  <header class="w3-container" style="padding-top:22px">
    <h5 ><b><i class="fa fa-dashboard"></i> My Dashboard</b></h5>
  </header>
  <mat-tab-group>
    <mat-tab label="Home"> 
      <br>
      <div *ngFor="let stat of mcStat  | async" class="w3-container">
    
        <p>My Total MC Answered - {{stat.total}} (Target: 1000)</p>
        <mat-progress-bar class="w3-theme-d1" style="height: 20px;" mode="determinate" value="{{stat.total / 1000 * 100}}"></mat-progress-bar>
          <br>
        <p>My MC Correct Rate - {{stat.correct}} / {{stat.total}} ({{stat.percentage | percent}})</p>
    
          <mat-progress-bar class="w3-theme-d1" style="height: 20px;" mode="determinate" value="{{stat.percentage * 100}}"></mat-progress-bar>
            
      
      </div>
      <hr>
      <div class="w3-container">
        <h5>Charts</h5>
        <mat-card>
          {{loadChart2(false)}}
        <div id="chartContainer6" style="height: 500px; width: 100%;">
          <mat-progress-bar *ngIf="loading == true" mode="indeterminate"></mat-progress-bar>
          <button *ngIf="loading == false" class="w3-theme-l1" mat-button (click)="loadChart2(true)"><i class="fa fa-refresh"></i> Reload</button>
        </div>
        </mat-card>

      </div>
      
      <hr>
    
      <div class="w3-panel">
        <div class="w3-row-padding" style="margin:0 -16px">

          <div class="w3-half">
            <h5>Charts</h5>
            <mat-card>
              {{loadChart(false)}}
            <div id="chartContainer5" style="height: 500px; width: 100%;">
              <mat-progress-bar *ngIf="loading == true" mode="indeterminate"></mat-progress-bar>
              <button *ngIf="loading == false" class="w3-theme-l1" mat-button (click)="loadChart(true)"><i class="fa fa-refresh"></i> Reload</button>
            </div>
            </mat-card>
          </div>
          <div  class="w3-half">
            <h5>Activities</h5>
            <div style="max-height: 550px; overflow: scroll;">
            <table  class="w3-table w3-striped w3-white">
              <tr>
                <th></th>
                <th>Paper Name</th>
                <th>Score</th>
                <th style="width: 20%"></th>
                <th>Date</th>
              </tr>
              <tr *ngFor="let record of mcRecord | async">
                <td><i class="fa fa-pencil w3-text-blue w3-large"></i></td>
                <td>{{record.type}} - {{record.tag}}</td>
                <td>{{record.score}} / {{record.fullmark}} </td>
                <td><mat-progress-bar mode="determinate" value="{{record.percentage * 100}}"></mat-progress-bar>({{record.percentage  | percent}})</td>
                <td><i>{{record.date}}</i></td>
              </tr>          
            </table>
          </div>
            
          </div>
        </div>
        <hr>
        <div class="w3-row-padding" style="margin:0 -16px">
          <div class="w3-container">
            <h5>Recent Comment</h5>
            <mat-card>
              <h5>Peter</h5>
            </mat-card>
            <br>
            <mat-card>
              <h5>Peter</h5>
            </mat-card>
          </div>
          
        </div>
      </div>
      <hr>
    </mat-tab>
    <mat-tab [disabled]="homeworks == ''"  label="My HW Grade"> 
      <div *ngIf="homeworks" class="w3-container ">
        <h5>My Assignment / Quiz Grade</h5>
        <table class="w3-table w3-striped w3-bordered w3-border w3-hoverable w3-white">
          <tr>
            <th style="width: 33%">Name</th>       
            <th style="width: 33%">Score</th>
            <th style="width: 33%"></th>
            
          </tr>
          <tr *ngFor="let homework of homeworks | slice:4;let i=index">         
            <td >{{homework[0]}}</td>      
            
            <td colspan="2"  *ngIf="homework[1]?.length >= 10"><a target="_blank" href="{{homework[1]}}"><i class="fa fa-external-link"></i> Open</a></td>
            <td colspan="2" *ngIf="homework[1] == '-'"><span class="w3-text-red">UNSUBMITTED</span></td>   
            <td *ngIf="homework[1] != '-' && homework[1]?.length < 10">{{homework[1]}} / {{fullhomeworks[i+4][1]}}</td>
            <td *ngIf="homework[1] != '-' && homework[1]?.length < 10">
              <div class="w3-theme-l5">
                <div [class.w3-theme-l4]="homework[1] / fullhomeworks[i+4][1] < 1"  [class.w3-green]="homework[1] / fullhomeworks[i+4][1]   == 1"  class="w3-container  " [style.width]="homework[1] / fullhomeworks[i+4][1]  | percent">{{homework[1] / fullhomeworks[i+4][1]  | percent}}</div>
                </div>
              
           
            
            </td>
          </tr>
          
          
        </table><br>
        
      </div>
    </mat-tab>
      </mat-tab-group>
  
  

  
  <hr>

  

 <!---
  <iframe class="not-active" width="100%" height="400px" src="https://www.watchisup.com/compte-a-rebours/embed/2020-dse-biology-2020-04-23-00-00?backgroundcolor=rgba(122%2C122%2C122%2C1)&color=%23ffffff" frameborder="0"  allowfullscreen></iframe>
-->
  <!-- Footer -->
  <footer class="w3-container w3-padding-16 w3-theme-d3">
    <h4>Bio.StudyDSE.net</h4>
    <p>Themed by <a href="https://www.w3schools.com/w3css/default.asp" target="_blank">w3.css</a> | <a href="https://material.angular.io/" target="_blank">Angular Material</a> | <a href="https://getbootstrap.com/" target="_blank">Bootstrap</a></p>
    <p>Frontend using <a href="https://angular.io/" target="_blank">Angular</a></p>
  </footer>

  <style type="text/css"> 
    .not-active { 
        pointer-events: none; 
        cursor: default; 
    } 
    </style> 